import React, { forwardRef } from "react";
import { FixedSizeList } from "react-window";

interface Props<T> {
  height: number;
  width: number;
  itemCount: number;
  rowHeight: number;
  itemData: T;
  renderer: (props: { data: T, index: number, style: React.CSSProperties }) => JSX.Element;
  ref: any
}

const VirtualizedFixedHeightList = forwardRef(<T extends unknown> (props: Props<T>, ref) => {
  return <FixedSizeList
    height={props.height}
    width={props.width}
    itemCount={props.itemCount}
    itemSize={props.rowHeight}
    itemData={props.itemData}
    ref={ref}
  >
    {props.renderer}
  </FixedSizeList>
});

export default VirtualizedFixedHeightList;
